/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import MonthlyClosingEvent from '../../event/MonthlyClosingEvent'
import { MonthlyClosingHeadState } from '../state/MonthlyClosingHeadState'

class MonthlyClosingHeadStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new MonthlyClosingHeadState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyClosingEvent.fetchOne:
        return state.mergeModel(payload.monthly_closing_head)

      case MonthlyClosingEvent.onEdit:
        return state.set(payload.name, payload.value)

      case MonthlyClosingEvent.onClear:
        return state.clear()

      default:
        return state
    }
  }
}

export default new MonthlyClosingHeadStore()
